import { userPermission, userRoleList, userList } from '@/api/system/auth';
import { getGlobalConfig } from '@/api/system/basic';
import { setRouter } from '@/router';

const actions = {
  // 获取权限列表
  getPermissions({ commit }) {
    userPermission({}).then(res => {
      commit('setMenus', res.data.menus);
      commit('setRouters', res.data.menus);
      commit('setPermissions', res.data.functions);
      setRouter(res.data.routers);
    });
  },
  // 获取用户列表
  getUsers({ commit, state }, projectId) {
    commit('setUsers', { [projectId]: [] });
    userRoleList({ project_id: projectId }).then(res => {
      // 对用户进行分组
      const currentUser = []; // 当前用户
      const normalUsers = []; // 普通用户
      const resignUsers = []; // 离职用户

      // 一次遍历，将用户分成三部分
      for (const user of res.data.items) {
        if (user.id === state.userInfo.id) {
          currentUser.push(user);
        } else if (user.status === 1) {
          resignUsers.push(user);
        } else {
          normalUsers.push(user);
        }
      }
      commit('setUsers', { [projectId]: [...currentUser, ...normalUsers, ...resignUsers] });
    });
  },
  // 获取所有用户列表
  getAllUsers({ commit }) {
    userList({}).then(res => {
      const userData = res.data.users || [];
      commit('setAllUsers', userData);
    });
  },
  getGlobalConfigList({ commit }) {
    getGlobalConfig().then(res => {
      commit('setGlobalConfig', res.data || {});
    });
  }
};

export default actions;
